import { render, staticRenderFns } from "./onFocus-editor.vue?vue&type=template&id=ccd01010&scoped=true&"
import script from "./onFocus-editor.vue?vue&type=script&lang=js&"
export * from "./onFocus-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd01010",
  null
  
)

export default component.exports